const Punjabi = {
    weekdays: {
        shorthand: ['ਐਤ', 'ਸੋਮ', 'ਮੰਗਲ', 'ਬੁੱਧ', 'ਵੀਰ', 'ਸ਼ੁੱਕਰ', 'ਸ਼ਨਿੱਚਰ'],
        longhand: [
            'ਐਤਵਾਰ',
            'ਸੋਮਵਾਰ',
            'ਮੰਗਲਵਾਰ',
            'ਬੁੱਧਵਾਰ',
            'ਵੀਰਵਾਰ',
            'ਸ਼ੁੱਕਰਵਾਰ',
            'ਸ਼ਨਿੱਚਰਵਾਰ',
        ],
    },
    months: {
        shorthand: [
            'ਜਨ',
            'ਫ਼ਰ',
            'ਮਾਰ',
            'ਅਪ੍ਰੈ',
            'ਮਈ',
            'ਜੂਨ',
            'ਜੁਲਾ',
            'ਅਗ',
            'ਸਤੰ',
            'ਅਕ',
            'ਨਵੰ',
            'ਦਸੰ',
        ],
        longhand: [
            'ਜਨਵਰੀ',
            'ਫ਼ਰਵਰੀ',
            'ਮਾਰਚ',
            'ਅਪ੍ਰੈਲ',
            'ਮਈ',
            'ਜੂਨ',
            'ਜੁਲਾਈ',
            'ਅਗਸਤ',
            'ਸਤੰਬਰ',
            'ਅਕਤੂਬਰ',
            'ਨਵੰਬਰ',
            'ਦਸੰਬਰ',
        ],
    },
    time24hr: true,
};

export default Punjabi;
export { Punjabi };
//# sourceMappingURL=pa.js.map
